(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3459],{

/***/ 74620:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ useAuthentication; }
/* harmony export */ });
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(35835);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(98431);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34587);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15129);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(648);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61395);
/* harmony import */ var _domains_cabinet_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7309);
/* harmony import */ var _utils_languageFormat__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16955);
/* harmony import */ var _domains_cabinet_slice__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63797);










var useAuthentication = function useAuthentication() {
  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(),
      lang = _useTranslation.lang;

  var formattedLang = (0,_utils_languageFormat__WEBPACK_IMPORTED_MODULE_7__/* .langFormatter */ .u)({
    lang: lang
  });

  var _useRouter = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(),
      push = _useRouter.push,
      pathname = _useRouter.pathname;

  var _cabinetHooks$useGetA = _domains_cabinet_api__WEBPACK_IMPORTED_MODULE_5__/* .hooks.useGetAccounts */ .PT.useGetAccounts(),
      _cabinetHooks$useGetA2 = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_cabinetHooks$useGetA, 1),
      trigger = _cabinetHooks$useGetA2[0];

  var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_3__/* .useDispatch */ .I0)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      loggedIn = _useState[0],
      setLoggedIn = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true),
      loading = _useState2[0],
      isLoading = _useState2[1];

  var checkUser = /*#__PURE__*/function () {
    var _ref = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)( /*#__PURE__*/_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
      var accounts;
      return _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!( true && sessionStorage.getItem('refreshToken'))) {
                _context.next = 22;
                break;
              }

              if (!pathname.startsWith('/login')) {
                _context.next = 5;
                break;
              }

              push('/cabinet');
              _context.next = 20;
              break;

            case 5:
              _context.prev = 5;
              _context.next = 8;
              return trigger({
                lang: formattedLang
              }).unwrap();

            case 8:
              accounts = _context.sent;
              sessionStorage.setItem('accountId', accounts[0].id);
              dispatch(_domains_cabinet_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.setAccounts */ .N.setAccounts(accounts));
              dispatch(_domains_cabinet_slice__WEBPACK_IMPORTED_MODULE_6__/* .actions.setSelectedAccountId */ .N.setSelectedAccountId(accounts[0].id));
              setLoggedIn(true);
              _context.next = 17;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context["catch"](5);

            case 17:
              _context.prev = 17;
              isLoading(false);
              return _context.finish(17);

            case 20:
              _context.next = 24;
              break;

            case 22:
              push('/login');
              sessionStorage.clear();

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 15, 17, 20]]);
    }));

    return function checkUser() {
      return _ref.apply(this, arguments);
    };
  }();

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    checkUser();
  }, []);
  return {
    loading: loading,
    loggedIn: loggedIn
  };
};

/***/ }),

/***/ 10527:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ Page; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67597);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
/* provided dependency */ var process = __webpack_require__(37008);

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */var s=function(){return s=Object.assign||function(e){for(var t,r=1,o=arguments.length;r<o;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e},s.apply(this,arguments)};function u(e,t,r,o){return new(r||(r=Promise))((function(n,a){function c(e){try{s(o.next(e))}catch(e){a(e)}}function i(e){try{s(o.throw(e))}catch(e){a(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(c,i)}s((o=o.apply(e,t||[])).next())}))}function l(e,t){var r,o,n,a,c={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return a={next:i(0),throw:i(1),return:i(2)},"function"==typeof Symbol&&(a[Symbol.iterator]=function(){return this}),a;function i(a){return function(i){return function(a){if(r)throw new TypeError("Generator is already executing.");for(;c;)try{if(r=1,o&&(n=2&a[0]?o.return:a[0]?o.throw||((n=o.return)&&n.call(o),0):o.next)&&!(n=n.call(o,a[1])).done)return n;switch(o=0,n&&(a=[2&a[0],n.value]),a[0]){case 0:case 1:n=a;break;case 4:return c.label++,{value:a[1],done:!1};case 5:c.label++,o=a[1],a=[0];continue;case 7:a=c.ops.pop(),c.trys.pop();continue;default:if(!(n=c.trys,(n=n.length>0&&n[n.length-1])||6!==a[0]&&2!==a[0])){c=0;continue}if(3===a[0]&&(!n||a[1]>n[0]&&a[1]<n[3])){c.label=a[1];break}if(6===a[0]&&c.label<n[1]){c.label=n[1],n=a;break}if(n&&c.label<n[2]){c.label=n[2],c.ops.push(a);break}n[2]&&c.ops.pop(),c.trys.pop();continue}a=t.call(e,c)}catch(e){a=[6,e],o=0}finally{r=n=0}if(5&a[0])throw a[1];return{value:a[0]?a[1]:void 0,done:!0}}([a,i])}}}var f,p=function(e){var t;e?function(e){if(e)for(;e.lastChild;)e.lastChild.remove()}("string"==typeof e?document.getElementById(e):e):(t=document.querySelector(".grecaptcha-badge"))&&t.parentNode&&document.body.removeChild(t.parentNode)},d=function(e,t){p(t),window.___grecaptcha_cfg=void 0;var r=document.querySelector("#"+e);r&&r.remove(),function(){var e=document.querySelector('script[src^="https://www.gstatic.com/recaptcha/releases"]');e&&e.remove()}()},y=function(e){var t=e.render,r=e.onLoadCallbackName,o=e.language,n=e.onLoad,a=e.useRecaptchaNet,c=e.useEnterprise,i=e.scriptProps,s=void 0===i?{}:i,u=s.nonce,l=void 0===u?"":u,f=s.defer,p=void 0!==f&&f,d=s.async,y=void 0!==d&&d,m=s.id,v=void 0===m?"":m,b=s.appendTo,h=v||"google-recaptcha-v3";if(function(e){return!!document.querySelector("#"+e)}(h))n();else{var g=function(e){return"https://www."+(e.useRecaptchaNet?"recaptcha.net":"google.com")+"/recaptcha/"+(e.useEnterprise?"enterprise.js":"api.js")}({useEnterprise:c,useRecaptchaNet:a}),S=document.createElement("script");S.id=h,S.src=g+"?render="+t+("explicit"===t?"&onload="+r:"")+(o?"&hl="+o:""),l&&(S.nonce=l),S.defer=!!p,S.async=!!y,S.onload=n,("body"===b?document.body:document.getElementsByTagName("head")[0]).appendChild(S)}},m=function(e){"undefined"!=typeof process&&!!process.env&&"production"!=="production"||console.warn(e)};!function(e){e.SCRIPT_NOT_AVAILABLE="Recaptcha script is not available"}(f||(f={}));var v=(0,react.createContext)({executeRecaptcha:function(){throw Error("GoogleReCaptcha Context has not yet been implemented, if you are using useGoogleReCaptcha hook, make sure the hook is called inside component wrapped by GoogleRecaptchaProvider")}}),b=v.Consumer;function h(t){var i=t.reCaptchaKey,u=t.useEnterprise,l=void 0!==u&&u,p=t.useRecaptchaNet,b=void 0!==p&&p,h=t.scriptProps,g=t.language,S=t.container,w=t.children,$=(0,react.useState)(null),C=$[0],P=$[1],x=(0,react.useRef)(i),E=JSON.stringify(h),R=JSON.stringify(null==S?void 0:S.parameters);(0,react.useEffect)((function(){if(i){var e=(null==h?void 0:h.id)||"google-recaptcha-v3",t=(null==h?void 0:h.onLoadCallbackName)||"onRecaptchaLoadCallback";window[t]=function(){var e=l?window.grecaptcha.enterprise:window.grecaptcha,t=s({badge:"inline",size:"invisible",sitekey:i},(null==S?void 0:S.parameters)||{});x.current=e.render(null==S?void 0:S.element,t)};return y({render:(null==S?void 0:S.element)?"explicit":i,onLoadCallbackName:t,useEnterprise:l,useRecaptchaNet:b,scriptProps:h,language:g,onLoad:function(){if(window&&window.grecaptcha){var e=l?window.grecaptcha.enterprise:window.grecaptcha;e.ready((function(){P(e)}))}else m("<GoogleRecaptchaProvider /> "+f.SCRIPT_NOT_AVAILABLE)},onError:function(){m("Error loading google recaptcha script")}}),function(){d(e,null==S?void 0:S.element)}}m("<GoogleReCaptchaProvider /> recaptcha key not provided")}),[l,b,E,R,g,i,null==S?void 0:S.element]);var M=(0,react.useCallback)((function(e){if(!C||!C.execute)throw new Error("<GoogleReCaptchaProvider /> Google Recaptcha has not been loaded");return C.execute(x.current,{action:e})}),[C,x]),N=(0,react.useMemo)((function(){return{executeRecaptcha:C?M:void 0,container:null==S?void 0:S.element}}),[M,C,null==S?void 0:S.element]);return react.createElement(v.Provider,{value:N},w)}var g=function(){return i(v)};function S(t){var r=this,o=t.action,a=t.onVerify,c=t.refreshReCaptcha,i=g();n((function(){var e=i.executeRecaptcha;if(e){u(r,void 0,void 0,(function(){var t;return l(this,(function(r){switch(r.label){case 0:return[4,e(o)];case 1:return t=r.sent(),a?(a(t),[2]):(m("Please define an onVerify function"),[2])}}))}))}}),[o,a,c,i]);var s=i.container;return"string"==typeof s?e.createElement("div",{id:s}):null}function w(e,t){return e(t={exports:{}},t.exports),t.exports
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */}var $="function"==typeof Symbol&&Symbol.for,C=$?Symbol.for("react.element"):60103,P=$?Symbol.for("react.portal"):60106,x=$?Symbol.for("react.fragment"):60107,E=$?Symbol.for("react.strict_mode"):60108,R=$?Symbol.for("react.profiler"):60114,M=$?Symbol.for("react.provider"):60109,N=$?Symbol.for("react.context"):60110,O=$?Symbol.for("react.async_mode"):60111,_=$?Symbol.for("react.concurrent_mode"):60111,T=$?Symbol.for("react.forward_ref"):60112,j=$?Symbol.for("react.suspense"):60113,L=$?Symbol.for("react.suspense_list"):60120,k=$?Symbol.for("react.memo"):60115,F=$?Symbol.for("react.lazy"):60116,A=$?Symbol.for("react.block"):60121,V=$?Symbol.for("react.fundamental"):60117,z=$?Symbol.for("react.responder"):60118,G=$?Symbol.for("react.scope"):60119;function I(e){if("object"==typeof e&&null!==e){var t=e.$$typeof;switch(t){case C:switch(e=e.type){case O:case _:case x:case R:case E:case j:return e;default:switch(e=e&&e.$$typeof){case N:case T:case F:case k:case M:return e;default:return t}}case P:return t}}}function D(e){return I(e)===_}var q={AsyncMode:O,ConcurrentMode:_,ContextConsumer:N,ContextProvider:M,Element:C,ForwardRef:T,Fragment:x,Lazy:F,Memo:k,Portal:P,Profiler:R,StrictMode:E,Suspense:j,isAsyncMode:function(e){return D(e)||I(e)===O},isConcurrentMode:D,isContextConsumer:function(e){return I(e)===N},isContextProvider:function(e){return I(e)===M},isElement:function(e){return"object"==typeof e&&null!==e&&e.$$typeof===C},isForwardRef:function(e){return I(e)===T},isFragment:function(e){return I(e)===x},isLazy:function(e){return I(e)===F},isMemo:function(e){return I(e)===k},isPortal:function(e){return I(e)===P},isProfiler:function(e){return I(e)===R},isStrictMode:function(e){return I(e)===E},isSuspense:function(e){return I(e)===j},isValidElementType:function(e){return"string"==typeof e||"function"==typeof e||e===x||e===_||e===R||e===E||e===j||e===L||"object"==typeof e&&null!==e&&(e.$$typeof===F||e.$$typeof===k||e.$$typeof===M||e.$$typeof===N||e.$$typeof===T||e.$$typeof===V||e.$$typeof===z||e.$$typeof===G||e.$$typeof===A)},typeOf:I},B=w((function(e,t){ false&&0})),J=(B.AsyncMode,B.ConcurrentMode,B.ContextConsumer,B.ContextProvider,B.Element,B.ForwardRef,B.Fragment,B.Lazy,B.Memo,B.Portal,B.Profiler,B.StrictMode,B.Suspense,B.isAsyncMode,B.isConcurrentMode,B.isContextConsumer,B.isContextProvider,B.isElement,B.isForwardRef,B.isFragment,B.isLazy,B.isMemo,B.isPortal,B.isProfiler,B.isStrictMode,B.isSuspense,B.isValidElementType,B.typeOf,w((function(e){ true?e.exports=q:0}))),K={childContextTypes:!0,contextType:!0,contextTypes:!0,defaultProps:!0,displayName:!0,getDefaultProps:!0,getDerivedStateFromError:!0,getDerivedStateFromProps:!0,mixins:!0,propTypes:!0,type:!0},U={name:!0,length:!0,prototype:!0,caller:!0,callee:!0,arguments:!0,arity:!0},H={$$typeof:!0,compare:!0,defaultProps:!0,displayName:!0,propTypes:!0,type:!0},Q={};function W(e){return J.isMemo(e)?H:Q[e.$$typeof]||K}Q[J.ForwardRef]={$$typeof:!0,render:!0,defaultProps:!0,displayName:!0,propTypes:!0},Q[J.Memo]=H;var X=Object.defineProperty,Y=Object.getOwnPropertyNames,Z=Object.getOwnPropertySymbols,ee=Object.getOwnPropertyDescriptor,te=Object.getPrototypeOf,re=Object.prototype;var oe=function e(t,r,o){if("string"!=typeof r){if(re){var n=te(r);n&&n!==re&&e(t,n,o)}var a=Y(r);Z&&(a=a.concat(Z(r)));for(var c=W(t),i=W(r),s=0;s<a.length;++s){var u=a[s];if(!(U[u]||o&&o[u]||i&&i[u]||c&&c[u])){var l=ee(r,u);try{X(t,u,l)}catch(e){}}}}return t},ne=function(t){var r=function(r){return react.createElement(b,null,(function(o){return react.createElement(t,s({},r,{googleReCaptchaProps:o}))}))};return r.displayName="withGoogleReCaptcha("+(t.displayName||t.name||"Component")+")",oe(r,t),r};
//# sourceMappingURL=react-google-recaptcha-v3.esm.js.map

// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(97043);
// EXTERNAL MODULE: ./components/common/index.js + 33 modules
var common = __webpack_require__(51633);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(648);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(61395);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(62049);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(26913);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./domains/cabinet/index.js + 1 modules
var cabinet = __webpack_require__(3519);
// EXTERNAL MODULE: ./components/SvgComponents/index.js + 147 modules
var SvgComponents = __webpack_require__(24052);
// EXTERNAL MODULE: ./components/ui/index.js + 100 modules
var ui = __webpack_require__(84838);
// EXTERNAL MODULE: ./components/login/AppBanner/AppBanner.module.scss
var AppBanner_module = __webpack_require__(27922);
var AppBanner_module_default = /*#__PURE__*/__webpack_require__.n(AppBanner_module);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(57611);
;// CONCATENATED MODULE: ./components/login/AppBanner/AppBanner.js






var AppBanner = function AppBanner(_ref) {
  var item = _ref.item;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: (AppBanner_module_default()).banner,
    itemScope: true,
    itemType: "https://schema.org/Offer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (AppBanner_module_default()).content,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (AppBanner_module_default()).imageBanner,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: "/assets/loginApp.svg",
          alt: "phone",
          title: "phone",
          layout: "fill",
          objectFit: "contain"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (AppBanner_module_default()).bottom,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (AppBanner_module_default()).title,
          children: t('common:Download our app')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (AppBanner_module_default()).subtitle,
          children: t('common:Download and qr')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (AppBanner_module_default()).store,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* StoreList */.Dz, {
            links: item === null || item === void 0 ? void 0 : item.links
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: (AppBanner_module_default()).image,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              src: item === null || item === void 0 ? void 0 : item.qr_image,
              alt: "Bakcell app qr-code",
              title: "Bakcell app qr-code",
              layout: "fill",
              placeholder: "blur",
              blurDataURL: item === null || item === void 0 ? void 0 : item.qr_image,
              loading: "lazy"
            })
          })]
        })]
      })]
    })
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(35835);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(98431);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(34587);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/formik/dist/formik.esm.js + 121 modules
var formik_esm = __webpack_require__(82065);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 25 modules
var yup_es = __webpack_require__(53431);
// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(52210);
// EXTERNAL MODULE: ./utils/formatPhoneNumber.js
var formatPhoneNumber = __webpack_require__(53836);
// EXTERNAL MODULE: ./utils/languageFormat.js
var languageFormat = __webpack_require__(16955);
// EXTERNAL MODULE: ./utils/generateInitialToken.js
var generateInitialToken = __webpack_require__(3937);
// EXTERNAL MODULE: ./components/login/LoginForm/LoginForm.module.scss
var LoginForm_module = __webpack_require__(54118);
var LoginForm_module_default = /*#__PURE__*/__webpack_require__.n(LoginForm_module);
;// CONCATENATED MODULE: ./components/login/LoginForm/LoginForm.js



















var LoginForm = function LoginForm(_ref) {
  var googleReCaptchaProps = _ref.googleReCaptchaProps;

  var _cabinetHooks$useSubs = cabinet/* hooks.useSubscriberCheck */.PT.useSubscriberCheck(),
      _cabinetHooks$useSubs2 = (0,slicedToArray/* default */.Z)(_cabinetHooks$useSubs, 2),
      subscribeTrigger = _cabinetHooks$useSubs2[0],
      _cabinetHooks$useSubs3 = _cabinetHooks$useSubs2[1],
      error = _cabinetHooks$useSubs3.error,
      isFetching = _cabinetHooks$useSubs3.isFetching;

  var _useSelector = (0,es/* useSelector */.v9)(cabinet/* selectors.selectCabinet */.wl.O),
      phoneNumber = _useSelector.phoneNumber;

  var _cabinetHooks$useOtpR = cabinet/* hooks.useOtpRequest */.PT.useOtpRequest(),
      _cabinetHooks$useOtpR2 = (0,slicedToArray/* default */.Z)(_cabinetHooks$useOtpR, 2),
      otpTrigger = _cabinetHooks$useOtpR2[0],
      otpFetching = _cabinetHooks$useOtpR2[1].isFetching;

  var _useState = (0,react.useState)(false),
      showError = _useState[0],
      setShowError = _useState[1];

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  var formattedLang = (0,languageFormat/* langFormatter */.u)({
    lang: lang
  });

  var _useState2 = (0,react.useState)(false),
      modalActive = _useState2[0],
      setModalActive = _useState2[1];

  var _useState3 = (0,react.useState)(null),
      token = _useState3[0],
      setToken = _useState3[1];

  var FormSchema = yup_es/* object */.Ry().shape({
    phone: yup_es/* string */.Z_().matches(/^\+994-\d{2}-\d{3}-\d{2}-\d{2}$/, t('common:Required')).required(t('common:Required'))
  });
  var getToken = (0,react.useCallback)( /*#__PURE__*/(0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
    var _token;

    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (googleReCaptchaProps !== null && googleReCaptchaProps !== void 0 && googleReCaptchaProps.executeRecaptcha) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            _context.prev = 2;
            _context.next = 5;
            return googleReCaptchaProps.executeRecaptcha('homepage');

          case 5:
            _token = _context.sent;
            setToken(_token);
            _context.next = 11;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context["catch"](2);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 9]]);
  })), [googleReCaptchaProps]);
  (0,react.useEffect)(function () {
    getToken();
  }, [getToken]);

  var cleanedPhoneNumber = function cleanedPhoneNumber(value) {
    return value.replace(/[+-]/g, '');
  };

  var formik = (0,formik_esm/* useFormik */.TA)({
    initialValues: {
      phone: '',
      terms: false
    },
    validationSchema: FormSchema,
    isInitialValid: false,
    onSubmit: function () {
      var _onSubmit = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(values) {
        var data, initialToken;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = {
                  phone: values === null || values === void 0 ? void 0 : values.phone
                };
                dispatch(cabinet/* actions.setPhoneNumber */.Nw.setPhoneNumber(cleanedPhoneNumber(data.phone)));
                _context2.prev = 2;
                initialToken = (0,generateInitialToken/* default */.Z)(cleanedPhoneNumber(data.phone), (0,v4/* default */.Z)());
                dispatch(cabinet/* actions.setInitialToken */.Nw.setInitialToken(initialToken));
                sessionStorage.setItem('initialToken', initialToken);
                _context2.next = 8;
                return subscribeTrigger({
                  msisdn: cleanedPhoneNumber(data.phone),
                  lang: formattedLang,
                  initialToken: initialToken,
                  recaptcha: token
                }).unwrap();

              case 8:
                modalHandler();
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](2);
                setShowError(true);

              case 14:
                _context2.prev = 14;
                formik.resetForm();
                return _context2.finish(14);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 11, 14, 17]]);
      }));

      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }

      return onSubmit;
    }()
  });

  var modalHandler = function modalHandler() {
    if (formik.isValid) {
      setModalActive(true);
    }
  };

  var _formikHandler = /*#__PURE__*/function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
      var data;
      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return otpTrigger({
                phoneNumber: phoneNumber,
                lang: formattedLang
              }).unwrap();

            case 3:
              data = _context3.sent;
              dispatch(cabinet/* actions.setUuId */.Nw.setUuId(data.uuid));
              dispatch(cabinet/* actions.nextStep */.Nw.nextStep());
              _context3.next = 11;
              break;

            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](0);
              setShowError(true);

            case 11:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 8]]);
    }));

    return function formikHandler() {
      return _ref3.apply(this, arguments);
    };
  }();

  var submitHandler = function submitHandler(e) {
    e.preventDefault();
    formik.setTouched({
      phone: true
    });
    formik.handleSubmit();
  };

  (0,react.useEffect)(function () {
    formik.validateForm();
    setModalActive(false);
  }, [lang]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("form", {
      className: (LoginForm_module_default()).form,
      onSubmit: function onSubmit(e) {
        return submitHandler(e);
      },
      "data-testid": "login-form",
      itemScope: true,
      itemType: "https://schema.org/Action",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: (LoginForm_module_default()).loginForm,
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Input */.II, {
          className: (LoginForm_module_default()).input,
          onBlur: formik.handleBlur('phone'),
          error: formik.touched.phone && formik.errors.phone,
          value: formik.values.phone,
          type: "tel",
          onChange: function onChange(value) {
            var formattedPhone = (0,formatPhoneNumber/* formatPhoneNumber */.u)(value);
            formik.setFieldValue('phone', formattedPhone);
          },
          label: t('common:Phone'),
          placeholder: '+994-XX-XXX-XX-XX',
          mask: '+\\9\\9\\4-99-999-99-99',
          "data-testid": 'cabinet-login-input'
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          "data-testid": 'login-continue-button',
          className: (LoginForm_module_default()).buttonFirst,
          disabled: isFetching,
          children: t('common:Continue')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: (LoginForm_module_default()).bottomTitle,
          children: /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
            children: [t('common:DontHaveBakcell'), " "]
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: (LoginForm_module_default()).buttons,
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/esim",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              className: "".concat((LoginForm_module_default()).button, " ").concat((LoginForm_module_default()).button__outlinebtn),
              variant: "outline",
              "data-testid": 'login-getEsim',
              children: t('common:GetEsim')
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
              className: "".concat((LoginForm_module_default()).button, " ").concat((LoginForm_module_default()).button__outlinebtn),
              variant: "outline",
              "data-testid": 'login-buy-number',
              children: t('cabinet:common.BuyBakcellNumber')
            })
          })]
        })]
      })
    }), modalActive && /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Terms */.Fe, {
      active: modalActive,
      formikHandler: function formikHandler() {
        _formikHandler();
      },
      innerText: t('cabinet:common.Terms'),
      setActive: function setActive() {
        return setModalActive(false);
      },
      isFetching: otpFetching,
      formik: formik
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
      active: showError,
      icon: "/assets/error.png",
      setActive: function setActive() {
        return setShowError(false);
      },
      children: error ? error.message : t('common:vacancies.error')
    })]
  });
};
// EXTERNAL MODULE: ./components/ui/OwnPhoneInput/OwnPhoneInput.js + 1 modules
var OwnPhoneInput = __webpack_require__(13507);
// EXTERNAL MODULE: ./hooks/useOtpVerification.js
var useOtpVerification = __webpack_require__(66972);
// EXTERNAL MODULE: ./components/common/RecordModal/CountDown.js
var CountDown = __webpack_require__(41728);
// EXTERNAL MODULE: ./utils/formatTimer.js
var formatTimer = __webpack_require__(67352);
// EXTERNAL MODULE: ./components/login/OtpVerify/OtpVerify.module.scss
var OtpVerify_module = __webpack_require__(5951);
var OtpVerify_module_default = /*#__PURE__*/__webpack_require__.n(OtpVerify_module);
;// CONCATENATED MODULE: ./components/login/OtpVerify/OtpVerify.js












var OtpVerify = function OtpVerify() {
  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var dispatch = (0,es/* useDispatch */.I0)();

  var _useOtpVerification = (0,useOtpVerification/* default */.Z)({
    isPopup: false
  }),
      isLoading = _useOtpVerification.isLoading,
      wrongOtp = _useOtpVerification.wrongOtp,
      showError = _useOtpVerification.showError,
      otpRequested = _useOtpVerification.otpRequested,
      otpValue = _useOtpVerification.otpValue,
      formatPhoneNumber = _useOtpVerification.formatPhoneNumber,
      submitHandler = _useOtpVerification.submitHandler,
      handleChangeOtpInput = _useOtpVerification.handleChangeOtpInput,
      closeError = _useOtpVerification.closeError,
      count = _useOtpVerification.count;

  var _useSelector = (0,es/* useSelector */.v9)(cabinet/* selectors.selectCabinet */.wl.O),
      phoneNumber = _useSelector.phoneNumber;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ScreenLoader */.v$, {
      visible: isLoading,
      itemScope: true,
      itemType: "https://schema.org/Thing"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (OtpVerify_module_default()).otpFormWrapper,
      itemScope: true,
      itemType: "https://schema.org/Action",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("form", {
        className: (OtpVerify_module_default()).otpFormWrapper__form,
        onSubmit: function onSubmit(e) {
          return submitHandler(e);
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: (OtpVerify_module_default()).otpText,
          children: t('cabinet:common.OTP')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (OtpVerify_module_default()).otpSubText,
          children: [t('cabinet:common.OtpSent'), " ", /*#__PURE__*/(0,jsx_runtime.jsx)("span", {}), formatPhoneNumber(phoneNumber)]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(CountDown/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(OwnPhoneInput/* default */.Z, {
          className: (OtpVerify_module_default()).otpInput,
          separationPoints: [],
          value: otpValue,
          onChange: handleChangeOtpInput,
          placeholder: "_"
        }), wrongOtp && /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
          className: (OtpVerify_module_default()).wrong_otp,
          children: [" ", t('cabinet:common.WrongOtp')]
        }), otpRequested ? /*#__PURE__*/(0,jsx_runtime.jsxs)(ui/* Button */.zx, {
          variant: "outline",
          className: "".concat((OtpVerify_module_default()).button, " ").concat((OtpVerify_module_default()).disabled),
          children: [t('cabinet:common.Timer'), " : ", (0,formatTimer/* formatTimer */.N)(count), "m"]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* Button */.zx, {
          className: "".concat((OtpVerify_module_default()).button, " ").concat((OtpVerify_module_default()).resend),
          variant: "normal",
          children: t('cabinet:common.ResendOtp')
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("span", {
          className: (OtpVerify_module_default()).belongsText,
          children: [t('cabinet:common.Belong'), ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            onClick: function onClick() {
              return dispatch(cabinet/* actions.prevStep */.Nw.prevStep());
            },
            className: (OtpVerify_module_default()).belongsText__inside,
            children: t('cabinet:common.EditNumber')
          })]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(ui/* ErrorModal */.Cv, {
        active: showError,
        icon: "/assets/error.png",
        setActive: closeError,
        children: t('common:vacancies.error')
      })]
    })]
  });
};
// EXTERNAL MODULE: ./components/login/Login/Login.module.scss
var Login_module = __webpack_require__(32999);
var Login_module_default = /*#__PURE__*/__webpack_require__.n(Login_module);
;// CONCATENATED MODULE: ./components/login/Login/Login.js












var Login = function Login(_ref) {
  var googleReCaptchaProps = _ref.googleReCaptchaProps,
      item = _ref.item;

  var _useSelector = (0,es/* useSelector */.v9)(cabinet/* selectors.selectCabinet */.wl.O),
      currentStep = _useSelector.currentStep;

  var _useTranslation = (0,useTranslation/* default */.Z)(),
      t = _useTranslation.t;

  var stepComponents = {
    1: /*#__PURE__*/(0,jsx_runtime.jsx)(LoginForm, {
      googleReCaptchaProps: googleReCaptchaProps
    }),
    2: /*#__PURE__*/(0,jsx_runtime.jsx)(OtpVerify, {})
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "".concat((Login_module_default()).loginWrapper, " wrapper"),
    itemScope: true,
    itemType: "https://schema.org/WebPage",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      "data-testid": "login-close-btn",
      className: (Login_module_default()).close,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
        href: "/",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(SvgComponents/* CloseMobile */.Rt, {})
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(AppBanner, {
      item: item
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: (Login_module_default()).loginFormWrapper,
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Login_module_default()).loginFormWrapper__logo,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
          href: "/",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
              alt: "logo",
              title: "logo",
              src: "/data/new-logo.svg",
              width: 228,
              height: 44
            })
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: (Login_module_default()).loginFormWrapper__title,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: t('cabinet:common.SignIn')
        })
      }), stepComponents[currentStep]]
    })]
  });
};
// EXTERNAL MODULE: ./utils/findWidget.js
var findWidget = __webpack_require__(97160);
// EXTERNAL MODULE: ./hooks/authHelper.js
var authHelper = __webpack_require__(74620);
;// CONCATENATED MODULE: ./pages/login/index.js







var __N_SSP = true;
function Page(_ref) {
  var data = _ref.data;
  (0,authHelper/* useAuthentication */.J)();
  var parsedData = JSON.parse(data);
  var applicationItem = (0,findWidget/* findWidget */.Z)(parsedData.widgets, 'application_banner');
  var LoginWrap = ne(Login);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(h, {
    reCaptchaKey: constants/* envVariables.NEXT_PUBLIC_RECAPTCHA_API_KEY_V3 */.ie.NEXT_PUBLIC_RECAPTCHA_API_KEY_V3,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(common/* Layout */.Ar, {
      navbar: parsedData.menu,
      metadata: parsedData === null || parsedData === void 0 ? void 0 : parsedData.metadata,
      breadcrumbs: parsedData === null || parsedData === void 0 ? void 0 : parsedData.breadcrumbs,
      appDownload: parsedData === null || parsedData === void 0 ? void 0 : parsedData.app_download_widget,
      withoutTheme: true,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(LoginWrap, {
        item: applicationItem
      })
    })
  });
}

/***/ }),

/***/ 97160:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ findWidget; }
/* harmony export */ });
var findWidget = function findWidget(widgets, widgetName) {
  var widget = widgets === null || widgets === void 0 ? void 0 : widgets.find(function (item) {
    return item.type === widgetName;
  });
  return widget;
};

/***/ }),

/***/ 42070:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/login",
      function () {
        return __webpack_require__(10527);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 27922:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"AppBanner_banner__ZTGB_","unionImage":"AppBanner_unionImage__360Zo","content":"AppBanner_content__EhD2a","imageBanner":"AppBanner_imageBanner__CuvmN","bottom":"AppBanner_bottom__Ber6G","title":"AppBanner_title__REjwL","subtitle":"AppBanner_subtitle__i6YiE","store":"AppBanner_store__1ZpOt","image":"AppBanner_image__l7iQ6","text":"AppBanner_text__ke3Q6","red":"AppBanner_red__DKN94"};

/***/ }),

/***/ 32999:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loginWrapper":"Login_loginWrapper__ZRjhd","close":"Login_close__YNqAp","loginFormWrapper":"Login_loginFormWrapper__fmuYZ","loginFormWrapper__title":"Login_loginFormWrapper__title__rNkRv","inside":"Login_inside__FZ0M0","loginFormWrapper__logo":"Login_loginFormWrapper__logo__9JA0D"};

/***/ }),

/***/ 54118:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"form":"LoginForm_form__dVWL0","loginForm":"LoginForm_loginForm__JEALG","input":"LoginForm_input__STwg3","bottomTitle":"LoginForm_bottomTitle__J3A_S","copyright":"LoginForm_copyright__6th3h","buttonFirst":"LoginForm_buttonFirst__70r7n","buttons":"LoginForm_buttons__jyRuK"};

/***/ }),

/***/ 5951:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"otpFormWrapper":"OtpVerify_otpFormWrapper__Mqul4","otpFormWrapper__popUp":"OtpVerify_otpFormWrapper__popUp__1LDEq","OwnPhoneInput":"OtpVerify_OwnPhoneInput__t0tTV","otpFormWrapper__form":"OtpVerify_otpFormWrapper__form__XzVtM","button":"OtpVerify_button__F5m_f","disabled":"OtpVerify_disabled__XTeqn","resend":"OtpVerify_resend__nD1hh","wrong_otp":"OtpVerify_wrong_otp__DL3Uq","otpInput":"OtpVerify_otpInput__8RcgI","otpText":"OtpVerify_otpText__KntGP","belongsText":"OtpVerify_belongsText__ABPLd","belongsText__inside":"OtpVerify_belongsText__inside__GWuPE","otpSubText":"OtpVerify_otpSubText__T74vB"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5443,1255,7847,6913,8922,5403,2030,9774,2888,179], function() { return __webpack_exec__(42070); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);